/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Update_FailedInputs */

const en_toast_update_failed = /** @type {(inputs: Toast_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The change could not be saved, so it was undone.`)
};

const de_toast_update_failed = /** @type {(inputs: Toast_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Änderung konnte nicht gespeichert werden und wurde zurückgenommen.`)
};

/**
* | output |
* | --- |
* | "The change could not be saved, so it was undone." |
*
* @param {Toast_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_update_failed = /** @type {((inputs?: Toast_Update_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Update_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_update_failed(inputs)
	return en_toast_update_failed(inputs)
});